import React, { useEffect, useMemo, useState } from "react";
import {
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";
import { isValidCPF, isValidFullName, isValidWhatsAppBR } from "../utils/validate";

interface DataTypes {
  idCliente: string | null;
  phone: string | null;
  name: string | null;
  cpf: string | null;
  message: string | null;
}

interface InviteContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  onInvite: (data: any) => void;
}

const InviteContactModal = ({
  isOpen,
  onClose,
  onInvite,
}: InviteContactModalProps) => {

  /*
  data input handeling
  */
  const [data, setData] = useState<DataTypes>({
    idCliente: "",
    phone: null,
    name: null,
    cpf: null,
    message: null,
  });

  const [idClienteTouched, setIdClienteTouched] = useState(false);
  const idClienteIsValid = useMemo(() => {
    if (!data.idCliente) return false;

    const value = Number(data.idCliente);
    return Number.isInteger(value) && value > 0;
  }, [data.idCliente]);
  // const idClienteIsValid = data.idCliente  ? true : false;

  const [cpfTouched, setCpfTouched] = useState(false);
  const cpfIsValid = isValidCPF(data.cpf ?? "");

  const [phoneTouched, setPhoneTouched] = useState(false);
  const phoneIsValid = isValidWhatsAppBR(data.phone ?? "");

  const [nameTouched, setNameTouched] = useState(false);
  const nameIsValid = isValidFullName(data.name ?? "");

  useEffect(() => {
    setData({
      idCliente: "",
      phone: null,
      name: null,
      cpf: null,
      message: null,
    });
  }, []);

  const onChangeData = (field: "idCliente" | "phone" | "name" | "cpf" | "message", value: string) => {
    let modifiedData: DataTypes = { ...data };
    if (value === "") {
      modifiedData[field] = null;
    } else {
      modifiedData[field] = value;
    }
    setData(modifiedData);
  };

  /*
  validation
  */
  const [valid, setValid] = useState<boolean>(false);

  useEffect(() => {
    if (phoneIsValid && nameIsValid && cpfIsValid) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [data, phoneIsValid, nameIsValid, cpfIsValid]);


  return (
    <Modal isOpen={isOpen} toggle={onClose} tabIndex={-1} centered scrollable >
      <ModalHeader toggle={onClose} className="bg-primary">
        <div className="modal-title-custom text-white font-size-16 ">
          Novo contato
        </div>
      </ModalHeader>
      <ModalBody className="p-4">
        <Form>

          {/* ID do Cliente */}
          <div className="mb-3">
            <Label htmlFor="AddContactModalidCliente-input" className="form-label">
              ID Cliente
            </Label>
            <Input
              type="text"
              id="AddContactModalidCliente-input"
              placeholder="Identificador"
              value={data.idCliente || ""}
              valid={idClienteTouched && idClienteIsValid}
              invalid={idClienteTouched && !idClienteIsValid}
              onBlur={() => setIdClienteTouched(true)}
              onChange={(e) => {
                // const onlyNumbers = e.target.value.replace(/\D/g, '');
                onChangeData("idCliente", e.target.value);
              }}
            />

            {idClienteTouched && !idClienteIsValid && (
              <div className="invalid-feedback d-block">
                Informe identificador do cliente - Finance (ex: 9999)
              </div>
            )}
          </div>

          {/* CPF do Cliente     */}
          <div className="mb-3">
            <Label htmlFor="AddContactModalCpfCliente-input" className="form-label">
              CPF do Cliente
            </Label>
            <Input
              type="text"
              id="AddContactModalCpfCliente-input"
              placeholder="Identificador"
              value={data.cpf || ""}
              valid={cpfTouched && cpfIsValid}
              invalid={cpfTouched && !cpfIsValid}
              onBlur={() => setCpfTouched(true)}
              onChange={(e) => {
                // const onlyNumbers = e.target.value.replace(/\D/g, '');
                onChangeData("cpf", e.target.value);
              }}
            />

            {cpfTouched && !cpfIsValid && (
              <div className="invalid-feedback d-block">
                Informe CPF do cliente - Finance válido
              </div>
            )}
          </div>



          <div className="mb-3">
            <Label htmlFor="AddContactModalphone-input" className="form-label">
              Celular
            </Label>
            <Input
              type="tel"
              id="AddContactModalphone-input"
              placeholder="5511998765432"
              value={data.phone || ""}
              valid={phoneTouched && phoneIsValid}
              invalid={phoneTouched && !phoneIsValid}
              onBlur={() => setPhoneTouched(true)}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/\D/g, '');
                onChangeData("phone", onlyNumbers);
              }}
            />

            {phoneTouched && !phoneIsValid && (
              <div className="invalid-feedback d-block">
                Informe um celular válido para WhatsApp (ex: 5511998765432)
              </div>
            )}
          </div>

          <div className="mb-3">
            <Label htmlFor="AddContactModalname-input" className="form-label">
              Nome completo
            </Label>
            <Input
              type="text"
              className="form-control"
              id="AddContactModalname-input"
              placeholder="Nome do contato"
              value={data["name"] || ""}
              valid={nameTouched && nameIsValid}
              invalid={nameTouched && !nameIsValid}
              onBlur={() => setNameTouched(true)}
              onChange={(e) => onChangeData("name", e.target.value)}
            />

            {nameTouched && !nameIsValid && (
              <div className="invalid-feedback d-block">
                Informe nome e sobrenome (mín. 4 letras)
              </div>
            )}

          </div>
          {/* <div className="">
            <Label
              htmlFor="AddContactModal-invitemessage-input"
              className="form-label"
            >
              Sua mensagem
            </Label>
            <textarea
              value={data["message"] || ""}
              onChange={(e: any) => {
                onChangeData("message", e.target.value);
              }}
              className="form-control"
              id="AddContactModal-invitemessage-input"
              rows={3}
              placeholder="Olá, Podemos falar no momento?"
            ></textarea>
          </div> */}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="link" className="btn" onClick={onClose}>
          Close
        </Button>
        <Button
          type="button"
          color="primary"
          disabled={!valid}
          onClick={() => onInvite(data)}
        >
          Enviar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default InviteContactModal;
